import { FormBuilder, AbstractControl } from '@angular/forms';

export function locationsGroup(formBuilder: FormBuilder): AbstractControl {
    return formBuilder.control([]);
}
